import Grid from "@Components/Grid";
import Paper from "@Components/Paper";
import { Dealership } from "@Types/dealerships";
import { renderFieldData } from "@Components/FieldData/RenderFieldData";

const DealershipInfo = ({ dealership }: { dealership: Dealership }) => {
  return (
    <Paper title="Dealership">
      <Grid container xs={12}>
        <Grid xs={12}>
          {renderFieldData("Name", dealership?.data?.info?.name ?? "N/A")}
        </Grid>
      </Grid>
    </Paper>
  );
};

export default DealershipInfo;
